<rappider-spin size="large"
               [spinning]="loading">
  <section>
    <rappider-title-toolbar [mainTitle]="mainTitle"
                            [options]="title"
                            [displayToolbar]="displayToolbar"
                            [displayToolbarBackButton]="displayToolbarBackButton">
    </rappider-title-toolbar>

    <div *ngIf="serverInfoAvailable"
         class="server-page-wrapper">
      <div class="title-wrapper">
        <rappider-paragraph content="Power (on/off)"
                            [typography]="{fontWeight:'bold', fontSize:'1.5rem'}"></rappider-paragraph>
        <rappider-switch [ngModel]="switchValue"
                         [loading]="(switchState !== applicationState)"
                         (valueChange)="onSwitchToggled($event)"></rappider-switch>
      </div>
      <nz-descriptions nzTitle="Backend Status"
                       [nzColumn]="1"
                       nzBordered>
        <nz-descriptions-item nzTitle="Created Date">{{backendInfo?.CreatedAt | date}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Status">{{backendInfo?.Status}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="State"
                              [nzSpan]="3">
          <nz-badge [nzStatus]="backendInfo?.State === 'running' ? 'success' : 'error'"
                    [nzText]="backendInfo?.State"></nz-badge>
        </nz-descriptions-item>
      </nz-descriptions>

      <nz-descriptions nzTitle="Frontend Status"
                       [nzColumn]="1"
                       nzBordered>
        <nz-descriptions-item nzTitle="Created Date">{{frontendInfo?.CreatedAt | date}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Status">{{frontendInfo?.Status}}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="State"
                              [nzSpan]="3">
          <nz-badge [nzStatus]="frontendInfo?.State === 'running' ? 'success' : 'error'"
                    [nzText]="frontendInfo?.State"></nz-badge>
        </nz-descriptions-item>
      </nz-descriptions>
    </div>
    <div *ngIf="!serverInfoAvailable">
      <div class="animation live-preview-in-progress-content-area">
        <rappider-alert class="live-preview-fail-info-alert"
                        [showIcon]="true"
                        type="info"
                        title="Server Unreachable"
                        description="You're seeing this warning because the server is currently unreachable.
                        You can click the Deploy button to deploy your source code to the server.
                        Once the deployment is complete, you’ll be able to preview your project."></rappider-alert>
      </div>
    </div>
  </section>

  <!-- <rappider-no-social-media-shared *ngIf="!isSocialMediaShared"></rappider-no-social-media-shared> -->
</rappider-spin>
